/**
 * Component: M12 Tabs
 * 
 */
'use strict';

export class Tabs
{
  constructor()
  {
    this.selectors = {
      component:    $('.c-v4-m12-tabs'),
      wrapper:      $('.c-v4-m12-tabs--main-wrapper'),
      accordion:    $('.c-v4-m12-tabs--main-wrapper .accordion'),
      items:        $('.c-v4-m12-tabs--main-item'),
      images:       $('.c-v4-m12-tabs--main-images-item')
    };
  }

  init()
  {
    let _self = this;

    this.selectors.items.on('mouseover', function()
    {
      let item = $(this).attr('data-item');

      _self.selectors.items.removeClass('active');
      _self.selectors.images.removeClass('active');

      $(this).addClass('active');

      _self.selectors.images.filter( function()
      {
        return ( $(this).attr('data-item') == item );
      }).addClass('active');
    });
  }
}
